import { render } from "./PrenatalWorkspace.vue?vue&type=template&id=5a4ff572&scoped=true"
import script from "./PrenatalWorkspace.vue?vue&type=script&lang=js"
export * from "./PrenatalWorkspace.vue?vue&type=script&lang=js"

import "./PrenatalWorkspace.vue?vue&type=style&index=0&id=5a4ff572&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4ff572"]])

export default __exports__